import { render } from "./TarjetaPop.vue?vue&type=template&id=d31dcec2&scoped=true"
import script from "./TarjetaPop.vue?vue&type=script&lang=js"
export * from "./TarjetaPop.vue?vue&type=script&lang=js"

import "./TarjetaPop.vue?vue&type=style&index=0&id=d31dcec2&lang=scss&scoped=true"

import exportComponent from "/Users/dracoghost/Documents/ProyectosFunkoPopMorelia/funkopopmorelia-catalogo-vue-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31dcec2"]])

export default __exports__